import React from "react";
import { useTheme } from "@emotion/react";

export interface CodeProps {
  text: string;
}

const Code: React.FC<CodeProps> = (props) => {
  const theme = useTheme();

  return (
    <span
      style={{
        color: theme.colours.grey["700"],
        backgroundColor: theme.colours.grey["200"],
        fontFamily: "Roboto Mono, monospace",
        fontSize: theme.fonts.size.text.xs,
        fontWeight: theme.fonts.weight.medium,
        padding: "2px 2px",
        borderRadius: 4,
        cursor: "text",
      }}
    >
      {props.text}
    </span>
  );
};

export default Code;
